import { Search } from 'lucide-react';
import type { DiagramSearchHit } from '../layout/DiagramChromeContext';

export function DiagramSearchField({
  query,
  onQueryChange,
  searchResults,
  onPickSearch,
}: {
  query: string;
  onQueryChange: (query: string) => void;
  searchResults: DiagramSearchHit[];
  onPickSearch: (id: string) => void;
}) {
  return (
    <div className="header-search">
      <label className="header-search-field focus-ring">
        <span className="sr-only">Пошук на схемі</span>
        <Search size={16} strokeWidth={1.75} className="text-gray-500 dark:text-gray-400" aria-hidden />
        <input
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Пошук: ключ моніторингу / назва"
        />
      </label>
      {searchResults.length > 0 ? (
        <div className="header-search-results" role="listbox" aria-label="Результати пошуку">
          {searchResults.slice(0, 8).map((node) => (
            <button
              key={node.id}
              type="button"
              className="header-search-item"
              onClick={() => onPickSearch(node.id)}
            >
              <span>{node.label}</span>
              <code>{node.monitorKey}</code>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
